<!-- PANE 4 -->
<div class="pane4">
  <mat-toolbar class="pane-header">

    <span>DETAILS AREA</span>
    <span class="spacer"></span>

    <!-- File operation buttons - always visible when viewing a file -->
    <ng-container *ngIf="isFilePreview()">
      <!-- Download button -->
      <button mat-icon-button color="primary" (click)="onDownloadFile()" matTooltip="Download this file">
        <mat-icon>download</mat-icon>
      </button>

      <!-- Replace button -->
      <button mat-icon-button color="accent" (click)="onReplaceFile()" matTooltip="Replace with a new file">
        <mat-icon>sync</mat-icon>
      </button>

      <!-- Delete button -->
      <button mat-icon-button color="warn" (click)="onDeleteFile()" matTooltip="Delete this file">
        <mat-icon>delete</mat-icon>
      </button>
    </ng-container>


    <!-- View mode button -->
    <button mat-icon-button [matMenuTriggerFor]="viewModeMenu" matTooltip="Change View Mode">
      <mat-icon>{{ getViewModeIcon() }}</mat-icon>
    </button>
    <mat-menu #viewModeMenu="matMenu">
      <!-- Layout toggle option -->
      <div class="layout-toggle-container" mat-menu-item (click)="$event.stopPropagation()">
        <span>View Layout:</span>
        <div class="toggle-with-label">
          <span class="toggle-label" [class.active-label]="viewMenuLayoutDirection === 'vertical'">Vertical</span>
          <mat-slide-toggle
            color="primary"
            [checked]="viewMenuLayoutDirection === 'horizontal'"
            (change)="toggleViewMenuLayout($event)">
          </mat-slide-toggle>
          <span class="toggle-label" [class.active-label]="viewMenuLayoutDirection === 'horizontal'">Horizontal</span>
        </div>
      </div>
      <mat-divider></mat-divider>

      <!-- View mode options - rendered based on layout direction -->
      <div [ngClass]="{'horizontal-layout': viewMenuLayoutDirection === 'horizontal'}">
        <button mat-menu-item
                [disabled]="viewMode === 'split' && !isInPopupMode()"
                (click)="setViewMode('split')"
                [class.selected-menu-item]="viewMode === 'split' && !isInPopupMode()">
          <mat-icon>view_column</mat-icon>
          <span>Side-Pane</span>
        </button>
        <button mat-menu-item
                [disabled]="isInPopupMode()"
                (click)="setViewMode('popup')"
                [class.selected-menu-item]="isInPopupMode()">
          <mat-icon>open_in_new</mat-icon>
          <span>Pop Out</span>
        </button>
        <button mat-menu-item
                [disabled]="viewMode === 'fullscreen'"
                (click)="setViewMode('fullscreen')"
                [class.selected-menu-item]="viewMode === 'fullscreen'">
          <mat-icon>fullscreen</mat-icon>
          <span>Full-Screen</span>
        </button>
      </div>
    </mat-menu>

    <!-- New close window button - always visible except in popup mode -->
    <button
            mat-icon-button
            class="close-window-button"
            (click)="closeDetailsWindow()"
            matTooltip="Close Window">
      <mat-icon>close</mat-icon>
    </button>

  </mat-toolbar>
  <mat-divider></mat-divider>
  <div class="pane-content">
    <!-- Empty details area - shown when no card is selected AND not loading -->
    <div class="empty-details" *ngIf="!selectedCard && !fileLoading">
      <p>Select content to view details</p>
    </div>

    <!-- Loading indicator for file loading -->
    <div *ngIf="fileLoading" class="file-loading-indicator">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading file... Please wait</p>
    </div>

    <!-- File preview area - uses the Card interface to pass file data -->
    <div *ngIf="selectedCard && !fileLoading" class="card-details">
      <!-- File preview -->
      <div *ngIf="isFilePreview()" class="file-preview">
        <h3>{{ selectedCard.questionText }}</h3>

        <!-- PDF viewer -->
        <iframe *ngIf="getFileType() === 'pdf'"
                [src]="selectedCard.imageUrl"
                class="file-iframe"
                frameborder="0"
                allowfullscreen>
        </iframe>

        <!-- Image viewer for PNG and JPEG -->
        <div *ngIf="getFileType() === 'png' || getFileType() === 'jpg' || getFileType() === 'jpeg'" class="image-viewer">
          <img [src]="selectedCard.imageUrl" alt="Image preview">
        </div>

        <!-- PNG Thumbnail viewer -->
        <div *ngIf="getFileType() === 'png_thumbnail'" class="image-viewer">
          <img [src]="selectedCard.imageUrl" alt="Thumbnail preview">
        </div>

        <!-- GIF viewer -->
        <div *ngIf="getFileType() === 'gif'" class="gif-viewer">
          <img [src]="selectedCard.imageUrl" alt="GIF preview">
          <div class="gif-controls">
            <button mat-icon-button (click)="toggleGifPlayback()" matTooltip="Play/Pause">
              <mat-icon>{{ isGifPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="restartGif()" matTooltip="Restart">
              <mat-icon>replay</mat-icon>
            </button>
          </div>
        </div>

        <!-- HTML viewer -->
        <div *ngIf="getFileType() === 'html'" class="html-viewer">
          <div class="html-controls">
            <button mat-button (click)="toggleHtmlView()" color="primary">
              {{ showRawHtml ? 'Show Rendered HTML' : 'Show HTML Source' }}
            </button>
          </div>

          <!-- HTML rendered view -->
          <div *ngIf="!showRawHtml" class="html-rendered">
            <iframe *ngIf="selectedCard.imageUrl"
                   [src]="selectedCard.imageUrl"
                   class="html-iframe"
                   frameborder="0"
                   sandbox="allow-same-origin allow-scripts">
            </iframe>
          </div>

          <!-- HTML source view -->
          <div *ngIf="showRawHtml" class="html-source">
            <pre><code>{{ selectedCard.fileData?.originalContent || selectedCard.fileData?.content }}</code></pre>
          </div>
        </div>

        <!-- ULTRA SIMPLE TEXT VIEWER - NO CONDITIONALS -->
        <div *ngIf="getFileType() === 'txt'">
          <div style=" padding: 20px; margin: 15px;">
            <h2>Text File Content</h2>
            <pre style="white-space: pre-wrap;
                       background: #f8f9fa;
                       border: 1px solid #dee2e6;
                       padding: 1rem;
                       font-family: 'Courier New', Courier, monospace;
                       font-size: 14px;
                       line-height: 1.5;
                       overflow: auto;
                       max-height: 700px;">{{ selectedCard.fileData?.content }}</pre>

            <div style="margin-top: 10px;">
              <a *ngIf="selectedCard.imageUrl" [href]="selectedCard.imageUrl" target="_blank"
                 style="display: inline-block; background: #007bff; color: white; padding: 8px 16px;
                        margin-right: 10px; text-decoration: none; border-radius: 4px;">
                <span style="font-weight: bold;">Open in Browser</span>
              </a>
              <a *ngIf="selectedCard.imageUrl" [href]="selectedCard.imageUrl" download
                 style="display: inline-block; background: #28a745; color: white; padding: 8px 16px;
                        text-decoration: none; border-radius: 4px;">
                <span style="font-weight: bold;">Download File</span>
              </a>
            </div>
          </div>
        </div>

        <!-- YouTube viewer -->
        <div *ngIf="getFileType() === 'youtube'" class="youtube-viewer">


          <!-- YouTube Video Player -->
          <div class="youtube-player-container">
            <iframe [src]="selectedCard.imageUrl"
                    class="youtube-iframe"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
            </iframe>
          </div>
        </div>

        <!-- Office documents: Preview as HTML if available -->
        <div *ngIf="getFileType() === 'docx' || getFileType() === 'xlsx'">
          <div *ngIf="selectedCard.fileData && selectedCard.fileData.contentType === 'html'">
            <div class="office-html-preview" [innerHTML]="selectedCard.fileData.content"></div>
          </div>
          <div *ngIf="!selectedCard.fileData || selectedCard.fileData.contentType !== 'html'" class="office-message">
            <div class="message-icon">
              <mat-icon>{{ getFileType() === 'docx' ? 'description' : 'table_chart' }}</mat-icon>
            </div>
            <h3>{{ getFileType().toUpperCase() }} Document</h3>
            <p>This document cannot be previewed directly in the browser.</p>
            <p>Please use one of the options below to view this file:</p>
            <div class="office-actions">
              <a [href]="getDownloadUrl()" target="_blank" class="open-button">
                <mat-icon>open_in_new</mat-icon> Open in browser
              </a>
              <a [href]="getDownloadUrl()" download class="download-button">
                <mat-icon>file_download</mat-icon> Download file
              </a>
            </div>
          </div>
        </div>

      </div>

      <!-- Question view - shown for regular question cards -->
      <div *ngIf="!isFilePreview()" class="question-details">
        <!-- Existing content for regular questions -->
      </div>
    </div>
  </div>
</div>
